import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { backendApi } from "../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { MdChevronRight } from "react-icons/md";
import {
  setCandidateData,
  setCandidateId,
} from "../../redux/reducers/loginSlice";
import { useDispatch } from "react-redux";
import Loading from "../../images/loading.gif";
import { Loader } from "react-feather";
import { FiXCircle } from "react-icons/fi";
import LoginImg from "../../images/login1.png";
import { FiX } from "react-icons/fi";
export default function CandidateLogin(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [dataFlag, setDataFlag] = useState(false);
  // localStorage?.setItem("isLogin", 1); //! Comment later
  const [siteDetails, setSiteDetails] = useState([]);

  useEffect(() => {
    getSiteDetails();
  }, []);

  const getSiteDetails = () => {
    const currentUrl = window.location.href;

    // Extract site ID from the URL
    const siteIdMatch = currentUrl.match(/\/(\d+)\/?$/);
    const siteId = siteIdMatch ? siteIdMatch[1] : "";

    // Extract web URL from the URL
    const webUrlMatch = currentUrl.match(/^(https?:\/\/[^\/]+)\/?/);
    const webUrl = webUrlMatch ? webUrlMatch[1] : "";
    var req = {
      functionName: "getSiteDetails",
      site_id: siteId ? siteId : "",
      web_url: webUrl ? webUrl : "",
    };
    backendApi(req).then((response) => {
      console.log("🚀 ~ backendApi ~ response:", response);
      if (response.success === "1") {
        setSiteDetails(response.dataSet);
        if (response.dataSet.length > 0) {
          localStorage.setItem("logo", response.dataSet[0].company_logo);
        }
      } else {
        return false;
      }
    });
  };

  const Login = (e) => {
    // e.preventDefault();
    if (userName === "") {
      toast.warn("Please enter your Username", { containerId: "D" });
      return false;
    } else if (password === "") {
      toast.warn("Please enter your password", { containerId: "D" });
      return false;
    }
    setDataFlag(true);
    var req = {
      functionName: "candidate_login",
      email_id: userName,
      password: password,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          console.log("userdata", response);
          console.log(response.candidate_id, "response.candidate_id[0].id");
          dispatch(setCandidateData(response.candidateData));
          dispatch(setCandidateId(response.candidate_id));
          localStorage.setItem("candidateId", response.candidateData[0].id);
          window.location.href = "/dashboard/candidateDashboard";
        } else {
          toast.warn("Wrong username or password", { containerId: "D" });
          return false;
        }
      })
      .finally(() => setDataFlag(false));
  };

  const handleForgotPwd = () => {
    if (userName === "") {
      toast.warn("Please enter your Username", { containerId: "D" });
      return false;
    }
    setDataFlag(true);
    var req = {
      functionName: "resetCandidatePassword",
      email_id: userName,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          toast.success("Password sent to your Email Account", {
            containerId: "D",
          });
          setForgotPassword(false);
        } else {
          toast.warn("Something went wrong", { containerId: "D" });
          return false;
        }
      })
      .finally(() => setDataFlag(false));
  };

  return (
    props.showCandidatePopUp && (
      <div className="login_popup">
        <ToastContainer
          enableMultiContainer
          containerId={"D"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="login_inner_popup">
          <FiX
            className="popup_close_div"
            onClick={() => props.hideCandidateLoginPopup()}
          />
          <div className="left_login_inner_popup">
            <div className="login_inner_svg">
              <img
                src={LoginImg}
                className="img-fluid"
                width="100%"
                height="100%"
              />
            </div>
          </div>
          <div className="right_login_inner_popup">
            <div className="login_head">Login</div>
            <div className="inner_login_container">
              {forgotPassword ? (
                <div className="login_form">
                  <input
                    type="text"
                    className="login_input"
                    placeholder="Email-Id"
                    value={userName}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  {dataFlag ? (
                    <button
                      className="login_btn"
                      type="button"
                      onClick={handleForgotPwd}
                    >
                      <img
                        src={Loading}
                        alt="loaderImg"
                        width={20}
                        height={20}
                      ></img>
                    </button>
                  ) : (
                    <button
                      className="login_btn"
                      type="button"
                      onClick={handleForgotPwd}
                    >
                      Submit
                    </button>
                  )}
                  <div className="d-flex align-items-center justify-content-between">
                    <p
                      className="mb-0 me-2 text-primary cursor-pointer"
                      onClick={() => setForgotPassword(false)}
                    >
                      Back to Login
                    </p>
                    <a
                      // onClick={() => navigate("/candidateSignup")}
                      className="btn btn-outline-primary btn-sm create-new"
                    >
                      Signup
                    </a>
                  </div>
                </div>
              ) : (
                <div className="login_form">
                  <input
                    type="text"
                    className="login_input"
                    placeholder="Email-Id"
                    value={userName}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <input
                    type={showPassword ? "text" : "password"}
                    className="login_input"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        Login(); // Call the Login method when the Enter key is pressed
                      }
                    }}
                  />
                  {dataFlag ? (
                    <button className="login_btn" type="button">
                      <img
                        src={Loading}
                        alt="loaderImg"
                        width={20}
                        height={20}
                      ></img>
                    </button>
                  ) : (
                    <button className="login_btn" type="button" onClick={Login}>
                      Log in
                    </button>
                  )}
                  <div className="py-3">
                    <span
                      className="text-muted"
                      style={{ cursor: "pointer" }}
                      onClick={() => setForgotPassword(true)}
                    >
                      Forgot password?
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 me-2 sign-in-form">
                      Don't have an account?
                    </p>
                    <a
                      href="/candidateSignup"
                      className="btn btn-outline-primary btn-sm create-new"
                    >
                      Signup
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
}
